const normalizedDecimal = (value: string) => {
  const [whole, decimals = ''] = value.replace(/^[+-]/, '').split('.')
  const integer = whole.replace(/^0+/, '') || '0'
  const fraction = decimals.replace(/0+$/, '')
  return { integer, fraction, negative: value.startsWith('-') && (integer !== '0' || fraction !== '') }
}

/** Compare decimal wire values without rounding amounts or extended-precision averages. */
export const compareDecimalAmounts = (left: string | null | undefined, right: string | null | undefined): number => {
  if (left == null) return right == null ? 0 : -1
  if (right == null) return 1
  const a = normalizedDecimal(left)
  const b = normalizedDecimal(right)
  if (a.negative !== b.negative) return a.negative ? -1 : 1

  let order = 0
  if (a.integer.length !== b.integer.length) order = a.integer.length < b.integer.length ? -1 : 1
  else if (a.integer !== b.integer) order = a.integer < b.integer ? -1 : 1
  else {
    const places = Math.max(a.fraction.length, b.fraction.length)
    const aFraction = a.fraction.padEnd(places, '0')
    const bFraction = b.fraction.padEnd(places, '0')
    if (aFraction !== bFraction) order = aFraction < bFraction ? -1 : 1
  }
  if (order === 0) return 0
  return a.negative ? -order : order
}
